import HttpStatus from 'redpoints-connector-common/enumeration/HttpStatus';
import FacilitatorValidationTaskController from 'redpoints-restapi-connector/controller/FacilitatorValidationTaskController';

import {
  CONNECTOR_REQUEST,
  FACILITATOR_VALIDATION_CLEAR,
  FACILITATOR_VALIDATION_CLEAR_FILTERS,
  FACILITATOR_VALIDATION_DELAY,
  FACILITATOR_VALIDATION_DONE,
  FACILITATOR_VALIDATION_FETCH_DOMAINS,
  FACILITATOR_VALIDATION_FETCH_NEXT_LINK_TASK_REQUEST,
  FACILITATOR_VALIDATION_SET_CONTENT_LINK_URLS,
  FACILITATOR_VALIDATION_SET_SELECTED_DOMAIN_ID,
  FACILITATOR_VALIDATION_SET_SELECTED_FILTER_BY_CUSTOMER,
  FACILITATOR_VALIDATION_SET_SELECTED_FILTERS,
} from './actionTypes';
import FacilitatorValidationService from '../services/FacilitatorValidationService';
import { translate } from '../helpers/languageHelper';

export const facilitatorValidationClear = () => ({
  type: FACILITATOR_VALIDATION_CLEAR,
});

export const facilitatorValidationClearFilters = () => ({
  type: FACILITATOR_VALIDATION_CLEAR_FILTERS,
});

export const facilitatorValidationDelay = ({ customerId, linkId }) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: FACILITATOR_VALIDATION_DELAY,
    connectorMethod:
      FacilitatorValidationTaskController.delayFacilitatorValidation,
    sortedParameters: [customerId, linkId],
    expectedStatus: HttpStatus.NO_CONTENT,
  },
});

export const facilitatorValidationDone = ({
  contentLinks,
  linkTaskRequest,
}) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: FACILITATOR_VALIDATION_DONE,
    connectorMethod: FacilitatorValidationService.save,
    sortedParameters: [contentLinks, linkTaskRequest],
    expectedStatus: HttpStatus.OK,
    mustShowErrorMessages: false,
    successfulMessage: translate('notification.action_successful'),
  },
});

export const facilitatorValidationFetchDomains = ({ customerId }) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: FACILITATOR_VALIDATION_FETCH_DOMAINS,
    connectorMethod:
      FacilitatorValidationTaskController.listDomainsForFacilitatorValidation,
    sortedParameters: [customerId],
    expectedStatus: HttpStatus.OK,
  },
});

export const facilitatorValidationFetchNext = ({ customerId, domainId }) => ({
  type: CONNECTOR_REQUEST,
  meta: {
    requestType: FACILITATOR_VALIDATION_FETCH_NEXT_LINK_TASK_REQUEST,
    connectorMethod:
      FacilitatorValidationTaskController.getNextFacilitatorValidation,
    sortedParameters: [customerId, domainId],
    expectedStatus: [HttpStatus.OK, HttpStatus.NOT_FOUND],
  },
});

export const facilitatorValidationSetSelectedFilters = ({
  domainId,
  filterByCustomer,
}) => ({
  type: FACILITATOR_VALIDATION_SET_SELECTED_FILTERS,
  payload: { domainId, filterByCustomer },
});

export const facilitatorValidationSetContentLinkUrls = ({
  contentLinkUrls,
}) => ({
  type: FACILITATOR_VALIDATION_SET_CONTENT_LINK_URLS,
  payload: { contentLinkUrls },
});

export const facilitatorValidationSetSelectedDomainId = ({ domainId }) => ({
  type: FACILITATOR_VALIDATION_SET_SELECTED_DOMAIN_ID,
  payload: { domainId },
});

export const facilitatorValidationSetSelectedFilterByCustomer = ({
  filterByCustomer,
}) => ({
  type: FACILITATOR_VALIDATION_SET_SELECTED_FILTER_BY_CUSTOMER,
  payload: { filterByCustomer },
});
